import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { FilterCondition, FilterDTO, FilterOperator, PagedResultDTOOfZoneDeviceDTO, SortDirection, ZoneDeviceClient } from 'src/app/base/models/models.swagger.generated';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';

@Injectable()
export class DeviceStateWidgetService extends ShowInactiveService implements IAdaptorService {

  public clientId: number;
  public zoneIds: number[];

  constructor(private zoneDeviceClient: ZoneDeviceClient) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfZoneDeviceDTO> {
    if (!this.clientId) {
      return of(new PagedResultDTOOfZoneDeviceDTO({items: [], totalNumberOfItems: 0}));
    }

    if (!filters) {
      filters = [];
    }
    filters.push(new FilterDTO({isComplex: false, field: 'Enabled', operator: FilterOperator.Equal, value: true.toString()}));

    if (this.zoneIds && this.zoneIds.length > 0) {
      filters.push(new FilterDTO({
        isComplex: true,
        condition: FilterCondition.Or,
        predicates: this.zoneIds.map( zoneId =>
          new FilterDTO({ isComplex: false, field: 'ZoneId', operator: FilterOperator.Equal, value: zoneId.toString()})
        )
      }));
    }

    return this.zoneDeviceClient.searchDevices(this.clientId, filters, skip, take, sortBy, sortDirection);
  }

  public addRecord(data: any): Observable<any> {
    return throwError(() => new Error('Not implemented'));
  }

  public deleteRecord(id: number): Observable<any> {
    return throwError(() => new Error('Not implemented'));
  }

  public updateRecord(data: any): Observable<any> {
    return throwError(() => new Error('Not implemented'));
  }
}
